var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'onfullScreen': _vm.off, 'unfullScreen': !_vm.off },on:{"click":_vm.fullScreen}},[(_vm.off)?_c('span',{staticClass:"fullScreen-text"},[_vm._v("全屏")]):_vm._e(),(!_vm.off)?_c('span',{staticClass:"fullScreen-text"},[_vm._v("退出全屏")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }